import { styled } from "styled-components";

import { LinkButton, Spacer, Text } from "@vericus/cadmus-ui";

interface Props {
  message: string;
  description?: string;
  action?: string;
  onAction?: VoidFunction;
}

/**
 * React component for custom Aphrodite toasts.
 */
export function ToastContent(props: Props) {
  const { message, description, action, onAction } = props;
  return (
    <Root>
      <Text kind="headingSix" color="inherit">
        {message}
        {action && (
          <ActionLink inline color="blueA500" onClick={onAction}>
            {action}
          </ActionLink>
        )}
      </Text>{" "}
      {description && (
        <>
          <Text kind="bodyMd" color="inherit">
            {description}
          </Text>
          <Spacer spacing={8} />
        </>
      )}
    </Root>
  );
}

const Root = styled.div`
  color: ${(p) => p.theme.colors.white100};
`;

const ActionLink = styled(LinkButton)`
  margin-left: 16px;
`;
